import React from 'react'
import { Container } from 'react-bootstrap'
import { addDaysToDateInString } from '../../../helpers'
import { ImageBase64 } from '../../image/image'
import * as S from './proposalElements'
import { IProposalCarImageSectionProps } from './proposalInterfaces/carImageSectionProps'
import globals from 'application/constants/globals'

const CarImageSection = (props: IProposalCarImageSectionProps) => {
  return (
    <div className="card-section">
      <Container className="section mt-4">
        {!props.pdf && (
          <>
            {props.proposalUpdatedDate && (
              <S.ProposalValidToDiv id="carimagesection.proposalvalidto">
                Proposal valid until{' '}
                {addDaysToDateInString(props.proposalUpdatedDate, 90)}
              </S.ProposalValidToDiv>
            )}
            <S.CarName>
              {props.vehicle.id && (
                <>
                  <span>
                    {props.vehicle.vehicleType === 'New' ? 'New ' : 'Used '}
                    <span id="carimagesection.vehicleyearmake">
                      {props.vehicle.year} {props.vehicle.make}{' '}
                    </span>
                    <span id="carimagesection.vehiclefamily">
                      {props.vehicle.family}
                    </span>
                  </span>
                </>
              )}
            </S.CarName>
            {props.vehicle.id && (
              <S.CarDescription id="carimagesection.vehicledescription">
                {props.vehicle.vehicleDescription}
              </S.CarDescription>
            )}
            {!props.vehicle.id && (
              <S.CarDescription
                className="text-dark-black mb-4"
                id="carimagesection.vehicledescription"
              >
                {props.vehicle.vehicleDescription}
              </S.CarDescription>
            )}
          </>
        )}
        <S.ImageContainerDiv>
          <S.ImageContainer className="mt-2 car-image car-image-large mb-3 pb-0">
            {props.vehicle.id && props.vehicle.vehicleImage && (
              <ImageBase64
                ImageBase64Encoded={props.vehicle.vehicleImage.base64Image}
                id="carimagesection.vehicleimage"
                style={{ maxWidth: '100%', maxHeight: '100%' }}
              />
            )}
            {(!props.vehicle.id || !props.vehicle.vehicleImage) && (
              <img
                src="/images/car-image-default.svg"
                alt=""
                id="carimagesection.vehicledefaultimage"
                style={{ maxWidth: '100%', maxHeight: '100%' }}
              />
            )}
          </S.ImageContainer>

          <S.ImageIndicativeText>
            Image is indicative only
          </S.ImageIndicativeText>
        </S.ImageContainerDiv>
      </Container>
    </div>
  )
}

export default CarImageSection
